import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-cargo-heating-download-popup',
  templateUrl: './cargo-heating-download-popup.component.html',
  styleUrls: ['./cargo-heating-download-popup.component.scss']
})
export class CargoHeatingDownloadPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<CargoHeatingDownloadPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  // Close popup and send result (csv/excel)
  selectOption(type: 'csv' | 'excel') {
    this.dialogRef.close(type);
  }

  // Cancel popup
  closePopup() {
    this.dialogRef.close();
  }
}
